import { useEffect } from 'react';
import useErrors from '../../error/useErrors';
import { useErrorStore } from '../../error';
import { serviceErrorSerializer } from './serviceErrors';
import { inputValidator } from './inputErrors';

/*
 * This serve as a wrapper for useErrors hook to configure the result of useErrors hook.
 */
function useAssetsErrors (props) {
    const store = useErrorStore();

    const {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    } = useErrors({
        useTouched: true,
        hook: 'useAssetsErrors',
        input: null,
        inputValidator,
        serviceErrorSerializer,
        errorObservables: [
            store.observed.errors.getPublisherLogo,
            store.observed.errors.authGetPublisherInfo,
            store.observed.errors.uploadProfileLogo,
        ],
    });

    useEffect(() => {
        // console.log('cehck errors', errors);
    }, [errors]);

    /*
     * This response will be consumed by the UI components...
     */
    return {
        errors,
        hasError,
        hasInputError,
        isGenericError,
    };
}

export default useAssetsErrors;
